var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardResolved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1556 15.6815L19.0211 5.81602C19.2539 5.5832 19.5255 5.4668 19.8359 5.4668C20.1463 5.4668 20.418 5.5832 20.6508 5.81602C20.8836 6.04883 21 6.3253 21 6.64542C21 6.96554 20.8836 7.242 20.6508 7.47482L9.97045 18.1843C9.73763 18.4171 9.46602 18.5335 9.1556 18.5335C8.84518 18.5335 8.57356 18.4171 8.34075 18.1843L3.33525 13.1788C3.10244 12.9459 2.99088 12.6695 3.00058 12.3494C3.01028 12.0292 3.13154 11.7528 3.36435 11.52C3.59717 11.2871 3.87363 11.1707 4.19375 11.1707C4.51387 11.1707 4.79034 11.2871 5.02315 11.52L9.1556 15.6815Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardResolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-resolved.7028b3e31461f93a8b0c9743c3938b68.svg";